// Handles overview's height to always be  around 350px height.
// For a 1920x1080 screen, the overview's height will overflow for more than approx. 300 groups
export function getGroupHeight(size: number) {
  if (size > 90) return 3;
  if (size > 70) return 4;
  if (size > 50) return 5;
  if (size > 35) return 7;
  return 10;
}
